import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";
import illustration from "assets/img/logonav.png";


export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex
      w="182.14px"
      h="40.002px"
      justifyContent="center"
      alignItems="center"
      aspectRatio="111.30/40.00">
      <img 
        src={illustration}
        alt="Logo"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      />
    </Flex>
  );
}

export default SidebarBrand;
